import React, {createContext, ReactNode, useContext} from 'react';
import {RootStore} from '../stores//RootStore';

let store: RootStore;

const StoreContext = createContext<RootStore | undefined>(undefined);

export function RootStoreProvider({children}: {children: ReactNode}) {
  const root = store ?? new RootStore();

  return <StoreContext.Provider value={root}>{children}</StoreContext.Provider>;
}

export function useRootStore() {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error('useRootStore must be used within RootStoreProvider');
  }

  return context;
}

export const useConferenceStore = () => useRootStore().conferenceStore;
export const useUserStore = () => useRootStore().userStore;
export const useAuthStore = () => useRootStore().authStore;
export const useClassStore = () => useRootStore().classStore;
export const useCreateClassStore = () => useRootStore().createClassStore;
export const useAnalyticsStore = () => useRootStore().analyticsStore;
export const useClassMetaDataStore = () => useRootStore().classMetaDataStore;
export const usePopUpStore = () => useRootStore().popUpStore;
export const useLoaderStore = () => useRootStore().loaderStore;
export const useAdminGeneralStore = () => useRootStore().adminGeneralStore;
export const useAdminTeachersStore = () => useRootStore().adminTeachersStore;
export const useAdminGroupsStore = () => useRootStore().adminGroupsStore;
export const useAdminGroupsStudentsStore = () => useRootStore().adminGroupsStudentsStore;
